import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)
const Home = () => import('../views/Home')
const News = () => import('../views/News')
const Detail = () => import('../views/Detail')
const Us = () => import('../views/Us')
const Msg = () => import('../views/Msg')

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/News',
      name: 'News',
      component: News,
      meta: {
        title: '新闻信息'
      }
    },
    {
      path: '/Detail/:id',
      name: 'Detail',
      component: Detail,
      meta: {
        title: '信息详情'
      }
    },
    {
      path: '/Us',
      name: 'Us',
      component: Us,
      meta: {
        title: '组织机构'
      }
    },
    {
      path: '/Msg',
      name: 'Msg',
      component: Msg,
      meta: {
        title: '留言'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js